var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-sm-5" }, [
      _c(
        "div",
        { staticClass: "card" },
        [
          _vm._m(0),
          _c("top-table", {
            ref: "tableSupplierDecoration",
            staticClass: "p-3",
            attrs: {
              isSelectable: true,
              columns: ["decorationName", "setups", "runs", "mapping"],
              sortable: ["decorationName"],
              "order-by": { column: "decorationName", ascending: 1 },
              headings: { decorationId: "ID" },
              "request-function": _vm.onBeforeReq,
              url: `/suppliers/${_vm.supplier._id}/decorations`,
              options: {
                perPage: 25,
                perPageValues: [100],
                orderBy: { column: "decorationName" },
              },
              "tab-filters": [
                {
                  label: "Only not mapped",
                  val: "notMapped",
                  criteria: [
                    { value: "Yes", name: "Yes" },
                    { value: "No", name: "No" },
                  ],
                },
              ],
              overlap: false,
            },
            scopedSlots: _vm._u([
              {
                key: "customAfterFilter",
                fn: function (props) {
                  return _c("span", {}, [
                    _c(
                      "div",
                      {
                        key: props.selected.length || -1,
                        staticClass: "mt-4 ml-2",
                      },
                      [
                        _c("FormModal", {
                          attrs: {
                            noSave: true,
                            disabled: !props.selected.length,
                            item: {
                              charges: [],
                              decorationNames: props.selected,
                              label: null,
                            },
                            supplier: _vm.supplier,
                          },
                          on: { change: (e) => _vm.onSave(props.row, e) },
                        }),
                      ],
                      1
                    ),
                  ])
                },
              },
              {
                key: "setups",
                fn: function (props) {
                  return [
                    props.row.setups.length
                      ? _c(
                          "div",
                          { staticClass: "d-flex align-items-center" },
                          [
                            props.row.setups.length > 0
                              ? _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "b-tooltip",
                                        rawName: "v-b-tooltip.hover",
                                        modifiers: { hover: true },
                                      },
                                    ],
                                    staticClass: "badge badge-primary ml-2 p-2",
                                    attrs: {
                                      title: props.row.setups.join(", "),
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(props.row.setups.length) +
                                        "\n            "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        )
                      : _c("div", [_vm._v("-")]),
                  ]
                },
              },
              {
                key: "runs",
                fn: function (props) {
                  return [
                    props.row.runs.length
                      ? _c(
                          "div",
                          { staticClass: "d-flex align-items-center" },
                          [
                            props.row.runs.length > 0
                              ? _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "b-tooltip",
                                        rawName: "v-b-tooltip.hover",
                                        modifiers: { hover: true },
                                      },
                                    ],
                                    staticClass: "badge badge-primary ml-2 p-2",
                                    attrs: { title: props.row.runs.join(", ") },
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(props.row.runs.length) +
                                        "\n            "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        )
                      : _c("div", [_vm._v("-")]),
                  ]
                },
              },
              {
                key: "mapping",
                fn: function (props) {
                  return [
                    _c(
                      "div",
                      {
                        key: props.row._id,
                        staticClass: "d-flex align-items-center",
                      },
                      [
                        _c("FormModal", {
                          attrs: {
                            noSave: true,
                            item: {
                              charges: [],
                              decorationNames: [props.row],
                              label: null,
                            },
                            supplier: _vm.supplier,
                          },
                          on: { change: (e) => _vm.onSave(props.row, e) },
                        }),
                        props.row.checked
                          ? _c("i", {
                              staticClass:
                                "far fa-check-circle text-success ml-2",
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ]),
    _c("div", { staticClass: "col-sm-7" }, [
      _c(
        "div",
        { staticClass: "card" },
        [
          _c(
            "div",
            { staticClass: "card-header d-flex justify-content-between" },
            [
              _vm._m(1),
              _c(
                "div",
                [
                  _c("ProductsFeeds", {
                    attrs: {
                      params: { suppliers: [_vm.supplier._id] },
                      "is-service": true,
                      label: `Suplier products locations`,
                      url: `/products/check-locations`,
                      labelProgress: `Products`,
                      help: `Check all supplier products selected locations`,
                    },
                  }),
                ],
                1
              ),
            ]
          ),
          _c("top-table", {
            ref: "tableDecoration",
            staticClass: "p-3",
            attrs: {
              columns: ["decorationNames", "setups", "run", "label", "actions"],
              sortable: ["decorationNames", "label"],
              "order-by": { column: "decorationNames", ascending: 1 },
              headings: { decorationId: "ID", label: "Price Includes" },
              "request-function": _vm.onBeforeReq,
              onLoadData: _vm.onLoadData,
              url: `/suppliers/${_vm.supplier._id}/dist-decorations`,
              tabFilters: _vm.tabFilters,
            },
            scopedSlots: _vm._u([
              {
                key: "tabsFilter",
                fn: function (props) {
                  return _c(
                    "div",
                    {
                      staticClass:
                        "mt-2 no-gutters d-flex flex-wrap align-items-center w-100",
                    },
                    [
                      _c("FormModal", {
                        attrs: {
                          item: {
                            charges: [],
                            decorationNames: [],
                            decorationUnitsIncluded: [],
                            decorationUnitsIncludedUom: [],
                            decorationUnitsMax: [],
                            label: null,
                          },
                          supplier: _vm.supplier,
                        },
                        on: { change: props.refresh },
                      }),
                    ],
                    1
                  )
                },
              },
              {
                key: "decorationNames",
                fn: function (props) {
                  return [
                    _c(
                      "div",
                      { staticClass: "d-flex align-items-center" },
                      [
                        _c("ProductsAll", {
                          attrs: {
                            query: `status=active&supplierId=${_vm.supplier._id}&decorationNames=${props.row.decorationNames}`,
                          },
                        }),
                        _c("FormModal", {
                          key: props.row.updatedAt,
                          attrs: {
                            isEdit: "",
                            item: props.row,
                            supplier: _vm.supplier,
                          },
                          on: { change: props.refresh },
                        }),
                      ],
                      1
                    ),
                  ]
                },
              },
              {
                key: "setups",
                fn: function (props) {
                  return [
                    props.row.charges.length
                      ? _c(
                          "div",
                          { staticClass: "d-flex align-items-center" },
                          [
                            props.row.charges.filter((e) => e.type === "setup")
                              .length > 0
                              ? _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "b-tooltip",
                                        rawName: "v-b-tooltip.hover",
                                        modifiers: { hover: true },
                                      },
                                    ],
                                    staticClass: "badge badge-primary ml-2 p-2",
                                    attrs: {
                                      title: props.row.charges
                                        .filter((e) => e.type === "setup")
                                        .map((e) => e.name)
                                        .join(", "),
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          props.row.charges.filter(
                                            (e) => e.type === "setup"
                                          ).length
                                        ) +
                                        "\n            "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        )
                      : _c("div", [_vm._v("-")]),
                  ]
                },
              },
              {
                key: "run",
                fn: function (props) {
                  return [
                    props.row.charges.length
                      ? _c(
                          "div",
                          { staticClass: "d-flex align-items-center" },
                          [
                            props.row.charges.filter((e) => e.type === "run")
                              .length > 0
                              ? _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "b-tooltip",
                                        rawName: "v-b-tooltip.hover",
                                        modifiers: { hover: true },
                                      },
                                    ],
                                    staticClass: "badge badge-primary ml-2 p-2",
                                    attrs: {
                                      title: props.row.charges
                                        .filter((e) => e.type === "run")
                                        .map((e) => e.name)
                                        .join(", "),
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          props.row.charges.filter(
                                            (e) => e.type === "run"
                                          ).length
                                        ) +
                                        "\n            "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        )
                      : _c("div", [_vm._v("-")]),
                  ]
                },
              },
              {
                key: "actions",
                fn: function (props) {
                  return [
                    _c("div", { staticClass: "d-flex align-items-center" }, [
                      _c(
                        "div",
                        { staticClass: "ml-1" },
                        [
                          _c("delete-button", {
                            attrs: {
                              remove: () => _vm.remove(props),
                              title: props.row.decorationNames[0],
                              btnClass: " btn-link",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h5", { staticClass: "card-title" }, [_vm._v("Decorations")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("h5", { staticClass: "card-title" }, [_vm._v("Mapped")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }